import React, { useContext } from 'react';
import styled from 'styled-components';
import HamQuest from '../../api/HamQuestGiver';
import { QuestRoute } from '../../api/QuestRoutes';
import { useParams } from 'react-router-dom';
import { useGlobalState } from '../../stateProvider/StateProvider';
import { getDaysInMonth, getMonths, translate } from '../../utility/functions';
import Button from '../../forms/Button';
import Input from '../../forms/Input';
import FormSetting from '../../layout/FormSetting';
import Select from '../../forms/Select';
import { HSOptions } from '../../../constants/HSOptions';
import Checkbox from '../../forms/Checkbox';
import PageBreak from '../../layout/PageBreak';
import Row from '../../layout/Row';
import LoyaltyPoints from './LoyaltyPoints';
import { userRoles } from '../../RoleProtected';
import PhoneNumberInput from '../../forms/formComponents/PhoneNumberInput';
import { UserContexts } from '../../stateProvider/UsersContext';
import ModalFactory from '../../Modal';
import UserMedia from '../../processors/UserMedias';

const Management = ({ userData, ...props }) => {
    const {
        state: {
            states,
            locations
        },
    } = useGlobalState();

    const context = useContext(UserContexts);

    const { guid } = useParams();

    const months = getMonths();

    const loyaltyMedias = context.user.loyaltyMedias?.filter(e => e.mediaType !== 'AppId');

    return (
        <PageBreak>
            <FormSetting
                label='Profile'
                inputs={{ ...context.user }}
                onSubmit={e => HamQuest.put(QuestRoute.user.info(guid), { ...e })
                    .then(() => context.refreshUser())
                }
                text='Update'
                roles={userRoles.editCustomers}
                editable
            >
                {({ values }) => (
                    <>
                        <Select
                            label='Account Status'
                            name='userStatus'
                            options={HSOptions.user.accountStatus}
                            required
                        />
                        <Row wrap>
                            <Input
                                label='Email'
                                name='email'
                                required
                            />
                            <PhoneNumberInput
                                name='cellPhoneNumber'
                            />
                        </Row>
                        <Row wrap>
                            <Input
                                label='First Name'
                                name='firstName'
                                required
                            />
                            <Input
                                label='Last Name'
                                name='lastName'
                                required
                            />
                        </Row>
                        <Row wrap>
                            <Input
                                label='Birth Day'
                                name='birthdayDay'
                                type='number'
                                min={1}
                                max={getDaysInMonth(values.birthdayMonth)}
                                options={months}
                            />
                            <Select
                                label='Birth Month'
                                name='birthdayMonth'
                                options={months}
                                nullable
                            />
                        </Row>
                        <Row wrap>
                            <Select
                                label='Billing Location'
                                name='assignedLocation'
                                options={locations}
                                nullable
                            />
                            <Checkbox
                                label='Locked Location'
                                name='merchantLocked'
                            />
                        </Row>
                    </>
                )}
            </FormSetting>


            {<FormSetting
                label='User Media'
                controls={[
                    <Button
                        onClick={() => ModalFactory.show({ title: 'User Media', body: <UserMedia userId={context.user.userId} states={states} refreshState={context.refreshUser} /> })}
                        label='Edit User Media'
                        icon='edit'
                    />]}
                wrapper
            >
                {loyaltyMedias.length ? loyaltyMedias.map((e, i) => (
                    <Input
                        key={`LM-${i}`}
                        label={translate(e.mediaType) + (e.backupPlate ? ' - (Backup)' : '')}
                        value={e.mediaId}
                        standalone
                        readOnly
                    />
                )) : <span>No Media on file.</span>}
            </FormSetting>}

            <FormSetting
                label='Vehicle'
                getInputs={QuestRoute.user.vehicle(guid)}
                onSubmit={e => HamQuest.put(QuestRoute.user.vehicle(guid), { ...e })}
                text='Update'
                editable
                roles={userRoles.editCustomers}
            >
                <Select
                    label='State'
                    name='state'
                    options={states}
                    nullable
                />
                <Input
                    label='Make'
                    name='make'
                    validate={/^(?!.*not\s+a).*$/gi}
                />
                <Input
                    label='Model'
                    name='model'
                    validate={/^(?!.*not\s+a).*$/gi}
                />
                <Input
                    label='Year'
                    name='year'
                    type='number'
                />
                <Input
                    label='Color'
                    name='color'
                    validate={/^(?!.*not\s+a).*$/gi}
                />
            </FormSetting>

            <LoyaltyPoints />
        </PageBreak >
    );
}

export default Management;
